import { render, staticRenderFns } from "./RecentActivityTableDescriptionBookingPaymentReminderSent.vue?vue&type=template&id=27fdc900&"
import script from "./RecentActivityTableDescriptionBookingPaymentReminderSent.vue?vue&type=script&lang=js&"
export * from "./RecentActivityTableDescriptionBookingPaymentReminderSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports